import {useState} from 'react';

import * as validations from '../../helpers/validations';
import CustomTextField from './CustomTextField';

const maskPhone = numStr => {
  if (numStr === '') return '';
  const result = numStr.split('').reduce((acc, next, i) => {
    if (i > -1 && i < 2) return `${acc}${next}`;
    if(i === 2) return `${acc}${next}) `;
    if (i >= 3 && i < 5) return `${acc}${next}`;
    if (i === 5) return `${acc}${next}-`;
    if (i > 9) return acc;
    return `${acc}${next}`;
  }, '(');
  return result;
};

const unmaskPhone = formattedNumStr => (
  (formattedNumStr || '').replace(/[\(\)\s\-]/g, '')
);

const handleChange = ({setValue, setTouched, onChange}) => e => {
  setTouched(true);
  const newValue = unmaskPhone(e.target.value);
  setValue(newValue);
  onChange({
    ...e,
    target: {...e.target, value: newValue}
  });
};

const PhoneInput = props => {
  const [touched, setTouched] = useState(false);
  const [value, setValue] = useState(props.defaultValue || '');
  return (
    <CustomTextField
      id='phone'
      label={props.hideLabel ? null : (props.label || 'Phone')}
      placeholder={props.placeholder || '(555) 555-5555'}
      variant='outlined'
      required={props.required}
      value={maskPhone(value)}
      error={touched && !validations.phone(value)}
      onFocus={() => setTouched(true)}
      onChange={handleChange({setValue, setTouched, onChange: props.onChange})}
      onBlur={props.onBlur || null}
      fullWidth={props?.fullWidth || false}
    />
  );
};

export default PhoneInput;
